// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.golf-leaderboard-table-container {
  width: 100%;
  max-width: 650px;
  margin: 0 auto;
  overflow-x: auto;
  background-color: transparent;
  box-shadow: none;
  border-radius: 0 !important;
}
.golf-leaderboard-table-container .golf-leaderboard-table {
  min-width: 500px;
  border-collapse: collapse;
  border-radius: 0;
}
.golf-leaderboard-table-container .golf-leaderboard-header-row {
  background-color: #072A34;
}
.golf-leaderboard-table-container .golf-leaderboard-header-row th {
  color: white;
  font-weight: 600;
  padding: 12px 6px;
  font-size: 14px;
  border-bottom: none;
}
.golf-leaderboard-table-container .golf-leaderboard-header-row .golf-leaderboard-rank-cell {
  color: #FFD700;
}
.golf-leaderboard-table-container .golf-leaderboard-row-even {
  background-color: white;
}
.golf-leaderboard-table-container .golf-leaderboard-row-odd {
  background-color: #f2f2f2;
}
.golf-leaderboard-table-container .golf-leaderboard-rank-cell {
  width: 50px;
  padding-left: 24px;
  font-weight: 600;
  font-size: 18px;
}
.golf-leaderboard-table-container .golf-leaderboard-player-cell {
  min-width: 200px;
}
.golf-leaderboard-table-container .golf-leaderboard-total-cell, .golf-leaderboard-table-container .golf-leaderboard-strokes-cell {
  min-width: 100px;
  text-align: center;
  font-weight: 500;
  font-size: 12px;
}
.golf-leaderboard-table-container .golf-leaderboard-player-info {
  display: flex;
  align-items: center;
}
.golf-leaderboard-table-container .golf-leaderboard-player-name-container {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.golf-leaderboard-table-container .golf-leaderboard-player-name {
  font-weight: 600;
  font-size: 12px !important;
  text-decoration: underline;
  color: #072A34;
  margin-right: 5px;
  white-space: nowrap;
}
.golf-leaderboard-table-container .golf-leaderboard-player-logo {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: contain;
  margin-right: 5px;
}
.golf-leaderboard-table-container .golf-leaderboard-rank-text, .golf-leaderboard-table-container .golf-leaderboard-total-text, .golf-leaderboard-table-container .golf-leaderboard-strokes-text {
  font-weight: 500;
  font-size: 12px;
}
.golf-leaderboard-table-container .golf-leaderboard-total-text {
  font-size: 12px !important;
  font-weight: 600;
}

@media (max-width: 768px) {
  .golf-leaderboard-table-container .golf-leaderboard-table {
    min-width: 400px;
  }
  .golf-leaderboard-table-container .golf-leaderboard-rank-cell {
    padding-left: 16px;
    width: 50px;
  }
  .golf-leaderboard-table-container .golf-leaderboard-player-cell {
    min-width: 160px;
  }
  .golf-leaderboard-table-container .golf-leaderboard-total-cell, .golf-leaderboard-table-container .golf-leaderboard-strokes-cell {
    min-width: 70px;
  }
  .golf-leaderboard-table-container .golf-leaderboard-rank-text, .golf-leaderboard-table-container .golf-leaderboard-total-text,
  .golf-leaderboard-table-container .golf-leaderboard-strokes-text, .golf-leaderboard-table-container .golf-leaderboard-player-name {
    font-size: 12px;
  }
  .golf-leaderboard-table-container .golf-leaderboard-player-logo {
    width: 32px;
    height: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/GolfLeague/LeaderboardPage/GolfOverallTable.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,2BAAA;AAAJ;AAEI;EACE,gBAAA;EACA,yBAAA;EACA,gBAAA;AAAN;AAGI;EACE,yBAAA;AADN;AAGM;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AADR;AAIM;EACE,cAAA;AAFR;AAMI;EACE,uBAAA;AAJN;AAOI;EACE,yBAAA;AALN;AAQI;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AANN;AASI;EACE,gBAAA;AAPN;AAUI;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AARN;AAWI;EACE,aAAA;EACA,mBAAA;AATN;AAYI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAVN;AAaI;EACE,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAXN;AAcI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAZN;AAeI;EACE,gBAAA;EACA,eAAA;AAbN;AAiBI;EACI,0BAAA;EACF,gBAAA;AAfN;;AAoBE;EAEI;IACE,gBAAA;EAlBN;EAqBI;IACE,kBAAA;IACA,WAAA;EAnBN;EAsBI;IACE,gBAAA;EApBN;EAuBI;IACE,eAAA;EArBN;EAwBI;;IAEE,eAAA;EAtBN;EAyBI;IACE,WAAA;IACA,YAAA;EAvBN;AACF","sourcesContent":["// LeaderboardTable.scss\n.golf-leaderboard-table-container {\n    width: 100%;\n    max-width: 650px;\n    margin: 0 auto;\n    overflow-x: auto;\n    background-color: transparent;\n    box-shadow: none;\n    border-radius: 0 !important;\n    \n    .golf-leaderboard-table {\n      min-width: 500px;\n      border-collapse: collapse;\n      border-radius: 0;\n    }\n    \n    .golf-leaderboard-header-row {\n      background-color: #072A34;\n      \n      th {\n        color: white;\n        font-weight: 600;\n        padding: 12px 6px;\n        font-size: 14px;\n        border-bottom: none;\n      }\n      \n      .golf-leaderboard-rank-cell {\n        color: #FFD700; // Gold color for RANK\n      }\n    }\n    \n    .golf-leaderboard-row-even {\n      background-color: white;\n    }\n    \n    .golf-leaderboard-row-odd {\n      background-color: #f2f2f2;\n    }\n    \n    .golf-leaderboard-rank-cell {\n      width: 50px;\n      padding-left: 24px;\n      font-weight: 600;\n      font-size: 18px;\n    }\n    \n    .golf-leaderboard-player-cell {\n      min-width: 200px;\n    }\n    \n    .golf-leaderboard-total-cell, .golf-leaderboard-strokes-cell {\n      min-width: 100px;\n      text-align: center;\n      font-weight: 500;\n      font-size: 12px;\n    }\n    \n    .golf-leaderboard-player-info {\n      display: flex;\n      align-items: center;\n    }\n    \n    .golf-leaderboard-player-name-container {\n      display: flex;\n      align-items: center;\n      flex-wrap: nowrap;\n    }\n    \n    .golf-leaderboard-player-name {\n      font-weight: 600;\n      font-size: 12px !important;\n      text-decoration: underline;\n      color: #072A34;\n      margin-right: 5px; // Exactly 5px space between name and logo\n      white-space: nowrap;\n    }\n    \n    .golf-leaderboard-player-logo {\n      width: 30px;\n      height: 30px;\n      border-radius: 50%;\n      object-fit: contain;\n      margin-right: 5px;\n    }\n    \n    .golf-leaderboard-rank-text, .golf-leaderboard-total-text, .golf-leaderboard-strokes-text {\n      font-weight: 500;\n      font-size: 12px;\n    }\n    \n    // Make negative scores (under par) stand out\n    .golf-leaderboard-total-text {\n        font-size: 12px !important;\n      font-weight: 600;\n    }\n  }\n  \n  // Responsive adjustments\n  @media (max-width: 768px) {\n    .golf-leaderboard-table-container {\n      .golf-leaderboard-table {\n        min-width: 400px;\n      }\n      \n      .golf-leaderboard-rank-cell {\n        padding-left: 16px;\n        width: 50px;\n      }\n      \n      .golf-leaderboard-player-cell {\n        min-width: 160px;\n      }\n      \n      .golf-leaderboard-total-cell, .golf-leaderboard-strokes-cell {\n        min-width: 70px;\n      }\n      \n      .golf-leaderboard-rank-text, .golf-leaderboard-total-text, \n      .golf-leaderboard-strokes-text, .golf-leaderboard-player-name {\n        font-size: 12px;\n      }\n      \n      .golf-leaderboard-player-logo {\n        width: 32px;\n        height: 32px;\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
